module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "pFrontCover"
    }
  }), _c('a', {
    attrs: {
      "id": "p1"
    }
  }), _c('a', {
    attrs: {
      "id": "p2"
    }
  }), _c('a', {
    attrs: {
      "id": "p3"
    }
  }), _c('a', {
    attrs: {
      "id": "p4"
    }
  }), _c('a', {
    attrs: {
      "id": "p5"
    }
  }), _c('a', {
    attrs: {
      "id": "p6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("First Mariner Books edition 2006"), _c('br'), _vm._v("\nCopyright © 1992 by Paul Theroux")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALL RIGHTS RESERVED")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("All rights reserved. For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the print edition as follows:")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Theroux, Paul."), _c('br'), _vm._v("\nThe happy isles of Oceania : paddling the Pacific / Paul"), _c('br'), _vm._v("\nTheroux.—1st Mariner Books ed."), _c('br'), _vm._v("\np. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Originally published: New York : G.P. Putnam’s Sons, "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("C")]), _vm._v("1992."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-618-65898-5 (pbk.)"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN-")]), _vm._v("10: 0-618-65898-x (pbk.)"), _c('br'), _vm._v("\n1. Oceania—Description and travel. 2. Oceania—History,"), _c('br'), _vm._v("\nLocal. 3. Theroux, Paul—Travel—Oceania. 4. Sea"), _c('br'), _vm._v("\nkayaking—Oceania. 1. Title."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DU")]), _vm._v("23.5."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v("47 2006 919.504—dc22"), _c('br'), _vm._v("\n2006028742")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("e"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-52518-1"), _c('br'), _vm._v("\nv3.0920")]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("The author gratefully acknowledges permission from Faber and Faber Ltd. for the lines from “Brother Fire” by Louis MacNeice. Reprinted from "), _c('em', [_vm._v("The Collected")]), _vm._v(" "), _c('em', [_vm._v("Poems of Louis MacNeice.")])]), _vm._v(" "), _c('p', {
    staticClass: "center spaceabove1"
  }, [_vm._v("Maps by Lisa Amoroso.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0223e7e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0